module.exports = __webpack_public_path__ + "img/gamifinnopolis.min.cfc1937a.svg";